import React from "react";
import ImageZoom from "react-medium-image-zoom";
import { Document, Page } from "react-pdf/dist/entry.webpack";
import { Dialog } from "@blueprintjs/core";

import classnames from "classnames";

class Viewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      pageNumbers: 1,
      pdfZoomed: false,
    };
  }
  onNext = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const newPage =
      this.state.pageNumber === this.state.pageNumbers
        ? 1
        : this.state.pageNumber + 1;
    this.setState({
      pageNumber: newPage,
    });
  };
  onPrevious = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const newPage =
      this.state.pageNumber === 1
        ? this.state.pageNumbers
        : this.state.pageNumber - 1;
    this.setState({
      pageNumber: newPage,
    });
  };
  onLoadSuccess = ({ numPages }) =>
    this.setState({ pageNumbers: numPages, pageNumber: 1 });
  render() {
    const { src, thumbnail, ...rest } = this.props;
    const { pageNumber, pageNumbers, pdfZoomed } = this.state;
    const isPdfFileType = src.match(/.pdf/i) != null;
    const isPdf = isPdfFileType || src.includes("data:application/pdf");
    const PageFooter = (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <button
          onClick={this.onPrevious}
          className="pt-button pt-icon-chevron-left"
        />
        <div
          style={{
            display: "flex",
            padding: "0 20px",
          }}
        >
          Page {pageNumber} of {pageNumbers}
        </div>
        <button
          onClick={this.onNext}
          className="pt-button pt-icon-chevron-right"
        />
      </div>
    );
    const PDF = (width, showPageFooter) => (
      <Document
        onLoadSuccess={this.onLoadSuccess}
        className={classnames({ thumbnail })}
        file={
          isPdfFileType
            ? src.replace("www.dropbox.com", "dl.dropboxusercontent.com")
            : src
        }
      >
        {showPageFooter && PageFooter}
        <Page pageNumber={pageNumber} width={width}></Page>
        {showPageFooter && PageFooter}
      </Document>
    );
    return isPdf ? (
      <div style={{ margin: "auto" }}>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.setState({ pdfZoomed: !pdfZoomed });
          }}
        >
          {PDF(thumbnail ? 30 : 600, !thumbnail)}
        </div>
        {pdfZoomed && (
          <Dialog
            style={{ width: "1000px" }}
            isOpen={pdfZoomed}
            onClose={() => this.setState({ pdfZoomed: false })}
            canOutsideClickClose={true}
            title="PDF Viewer"
          >
            {PDF(1000, true)}
          </Dialog>
        )}
      </div>
    ) : (
      <ImageZoom image={{ src, ...rest }} />
    );
  }
}

export { Viewer };



// WEBPACK FOOTER //
// ./src/components/widgets/Viewer.js